import { createFileRoute, redirect } from '@tanstack/react-router'
import { AdminSettings } from '@/components/admin/AdminSettings'

// Keep in step with NAV_ITEMS in AdminSettings.tsx. ('marketing-qr' left for
// good — that tab moved to /admin/marketing/qr-codes.)
const VALID_SETTINGS_SECTIONS = new Set([
  'general',
  'public-links',
  'financial',
  'receipt',
  'fiscal',
  'order-types',
  'kitchen',
])

// 'pra' (the old standalone "Tax Invoice Settings" tab) was merged into the
// 'fiscal' page. Alias it so existing links/bookmarks still resolve.
const SETTINGS_SECTION_ALIASES: Record<string, string> = { pra: 'fiscal' }

export const Route = createFileRoute('/admin/settings')({
  // The storefront editor left Settings for its own sidebar page, Website.
  // Old links (?section=storefront-appearance) land there instead of on
  // General.
  beforeLoad: ({ search }) => {
    if ((search as { section?: unknown }).section === 'storefront-appearance') throw redirect({ to: '/admin/website', search: { tab: 'design' } })
  },
  validateSearch: (raw: Record<string, unknown>) => {
    const s = raw.section
    if (typeof s !== 'string') return { section: undefined }
    const resolved = SETTINGS_SECTION_ALIASES[s] ?? s
    if (resolved === 'storefront-appearance') return { section: resolved }
    const section = VALID_SETTINGS_SECTIONS.has(resolved) ? resolved : undefined
    return { section }
  },
  component: function AdminSettingsRoute() {
    const { section } = Route.useSearch()
    return <AdminSettings initialUrlSection={section} />
  },
})
